import React from 'react';
import { AtlasDashboard } from 'pages/AtlasDashboard';

export const Landing = () => {
	return <AtlasDashboard />;
};
